import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  MenuItem,
  Paper,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
  ExcelExportColumnGroup,
} from "@progress/kendo-react-excel-export";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import SelectAutoComplete from "../../components/SelectAutoComplete";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as agentAction } from "../../redux/agent";
import { mapActionsToProps } from "../../redux/report/agent";
import { mapActionsToProps as reportTicketAction } from "../../redux/report/reportTicket";
import { parseAutoFillDate } from "../../ultis/autoFillDate";

class ReportTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          from: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
          to: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD"),
          source: "inbound",
          agentId: null,
        },
        page: 0,
        pageSize: 20,
      },
      agentId: null,
      listAgents: [],
      selectedAgent: "",
      currentStartDate: null,
      currentEndDate: null,
    };
  }

  async componentDidMount() {
    const { filters } = this.state;
    this.history = globalHistory();
    this.props.getListAgent(null, null, null, null, null, { query: "all" });
    this.props.getListReportTicket(
      filters.where.agentId,
      `${filters.where.from}`,
      `${filters.where.to}`,
      filters.where.source
    );
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      nextState.currentStartDate === null && nextState.currentEndDate === null
    );
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.listAgents)) !==
        JSON.parse(JSON.stringify(_.values(props.listAgents))) &&
      !state.listAgents
    ) {
      return {
        listAgents: _.values(props.listAgents),
      };
    }
    return null;
  }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "agentId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    time: {
                      gte: datetimeHelper.toFormat(
                        this.state.filters.where.gte,
                        "YYYY-MM-DD startDay"
                      ),
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    time: {
                      lte: datetimeHelper.toFormat(
                        this.state.filters.where.lte,
                        "YYYY-MM-DD endDay"
                      ),
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
  }

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleSubmit = (e) => {
    const { filters } = this.state;
    if (filters.where.to && filters.where.from) {
      filters.skip = 0;
      if (this.state.selectedAgent) {
        filters.where["agentId"] = this.state.selectedAgent;
      } else {
        delete filters.where["agentId"];
      }
      this.setState({ disable: false });
      this.props.getListReportTicket(
        filters.where.agentId,
        `${filters.where.from}`,
        `${filters.where.to}`,
        filters.where.source
      );
    }
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = from
      ? datetimeHelper.toFormat(from, "YYYY-MM-DD")
      : null;
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = to ? datetimeHelper.toFormat(to, "YYYY-MM-DD") : null;
    this.setState({ to });
  };

  handleChange = (name) => {
    const { filters } = this.state;
    return (e) => {
      filters.where[name] = e.target.value;
      return this.setState({
        filters,
      });
    };
  };

  _export;
  export = () => {
    this._export.save();
  };

  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              (item &&
                item.code &&
                item.code.toLowerCase().includes(search.toLowerCase())) ||
              (item &&
                item.user &&
                item.user.fullname &&
                item.user.fullname.toLowerCase().includes(search.toLowerCase()))
          )
        : array;
    }
    return array;
  };

  handleSearchUser = (text) => {
    const { listAgents } = this.props;
    this.setState({
      listAgents: this.filterCustomers(_.values(listAgents), text),
    });
  };

  render() {
    const { classes, listReportTicket } = this.props;
    const { filters } = this.state;
    const listReportTicketResult =
      typeof listReportTicket === "object"
        ? Object.keys(listReportTicket).map((key) => listReportTicket[key])
        : listReportTicket;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={2}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          label="Chọn báo cáo"
                          variant="outlined"
                          className={classes.input}
                          value={"inbound"}
                          onChange={this.handleChange("source")}
                          name="source"
                          InputLabelProps={{
                            shrink: true,
                          }}>
                          <MenuItem value="inbound">
                            Báo cáo ticket inbound
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item md={2} style={{ marginTop: "6px" }}>
                        <SelectAutoComplete
                          label={"Mã điện thoại viên"}
                          data={
                            this.state.listAgents &&
                            this.state.listAgents.length > 0
                              ? this.state.listAgents.map((val) => {
                                  return {
                                    id: val.id,
                                    label: val.user
                                      ? `${val.code} - ${val.user.fullname}`
                                      : "",
                                  };
                                })
                              : []
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchUser(text),
                            300
                          )}
                          onChange={(item) => {
                            this.setState(
                              {
                                selectedAgent: item ? item.id : "",
                              },
                              () => {
                                this.handleSubmit();
                              }
                            );
                          }}
                          className={classes.input}
                          onClear={true}
                          name="agentId"
                        />
                      </Grid>
                      <Grid item md={2}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.from ? filters.where.from : null}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                          maxDate={
                            filters.where.to ? filters.where.to : new Date()
                          }
                          required={true}
                          ampm={false}
                          keyboard
                          invalidDateMessage="Định dạng Ngày không đúng"
                          maxDateMessage="Ngày lớn hơn ngày tối đa"
                          minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                          onBlur={() => {
                            this.handleDateChangeStart(
                              this.state.currentStartDate
                                ? parseAutoFillDate(this.state.currentStartDate)
                                : null
                            );
                            this.setState({ currentStartDate: null });
                          }}
                          onKeyUp={(e) => {
                            this.setState({ currentStartDate: e.target.value });
                          }}
                        />
                        {/*{!filters.where.from &&*/}
                        {/*    <p className="error-messages" style={{position: 'absolute', top: '72px'}}>Không được để trống</p>*/}
                        {/*}*/}
                      </Grid>
                      <Grid item md={2}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.to ? filters.where.to : null}
                          maxDate={new Date()}
                          minDate={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                          required={true}
                          ampm={false}
                          keyboard
                          invalidDateMessage="Định dạng Ngày không đúng"
                          maxDateMessage="Ngày lớn hơn ngày tối đa"
                          minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                          onBlur={() => {
                            this.handleDateChangeEnd(
                              this.state.currentEndDate
                                ? parseAutoFillDate(this.state.currentEndDate)
                                : null
                            );
                            this.setState({ currentEndDate: null });
                          }}
                          onKeyUp={(e) => {
                            this.setState({ currentEndDate: e.target.value });
                          }}
                        />
                        {/*{!filters.where.to &&*/}
                        {/*    <p className="error-messages" style={{position: 'absolute', top: '72px'}}>Không được để trống</p>*/}
                        {/*}*/}
                      </Grid>
                      <Grid
                        item
                        md={2}
                        style={{ alignItem: "center", display: "flex" }}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            type="submit"
                            // onClick={this.handleSubmit}
                          >
                            <Search />
                          </Fab>
                        </Tooltip>
                        <Tooltip title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            onClick={this.export}
                            className={classes.fab}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
                <ExcelExport
                  data={listReportTicketResult}
                  fileName="Báo cáo ticket và tổng số cuộc gọi điện thoại viên.xlsx"
                  ref={(exporter) => (this._export = exporter)}>
                  <ExcelExportColumn field="date" title="Ngày" width={80} />
                  <ExcelExportColumn
                    field="agentCode"
                    title="Mã điện thoại viên"
                    width={110}
                  />
                  <ExcelExportColumn
                    field="agentName"
                    title="Tên điện thoại viên"
                    width={110}
                  />
                  <ExcelExportColumnGroup
                    title="Phản ánh khiếu nại"
                    headerCellOptions={{ textAlign: "center" }}>
                    <ExcelExportColumn
                      field="paknHaveLead"
                      title="Có lead"
                      width={80}
                    />
                    <ExcelExportColumn
                      field="paknNoLead"
                      title="Không có lead"
                      width={100}
                    />
                  </ExcelExportColumnGroup>
                  <ExcelExportColumnGroup
                    title="Tư vấn, sử dụng dịch vụ"
                    headerCellOptions={{ textAlign: "center" }}>
                    <ExcelExportColumn
                      field="sddvHaveLead"
                      title="Có lead"
                      width={80}
                    />
                    <ExcelExportColumn
                      field="sddvNoLead"
                      title="Không có lead"
                      width={100}
                    />
                  </ExcelExportColumnGroup>
                  <ExcelExportColumnGroup
                    title="Yêu cầu hỗ trợ"
                    headerCellOptions={{ textAlign: "center" }}>
                    <ExcelExportColumn
                      field="ychtHaveLead"
                      title="Có lead"
                      width={80}
                    />
                    <ExcelExportColumn
                      field="ychtNoLead"
                      title="Không có lead"
                      width={100}
                    />
                  </ExcelExportColumnGroup>
                  <ExcelExportColumn
                    field="sumTicket"
                    title="Tổng số ticket"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="sumInboundCall"
                    title="Tổng số cuộc gọi"
                    width={100}
                  />
                  <ExcelExportColumn
                    field="inbNoTicket"
                    title="Tổng số cuộc gọi chưa tạo ticket"
                    width={120}
                  />
                </ExcelExport>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Ngày
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Mã điện thoại viên
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tên điện thoại viên
                </TableCell>
                <TableCell
                  colSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Phản ánh khiếu nại
                </TableCell>
                <TableCell
                  colSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tư vấn, sử dụng dịch vụ
                </TableCell>
                <TableCell
                  colSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Yêu cầu hỗ trợ
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tổng số ticket
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tổng số cuộc gọi
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tổng số cuộc gọi chưa tạo ticket
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    borderTop: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Có lead
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Không có lead
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Có lead
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Không có lead
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Có lead
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Không có lead
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listReportTicketResult != 0
                ? listReportTicketResult.map((row, key) => {
                    return (
                      <TableRow key={key} className={classes.row}>
                        {row.groups.date.index === 0 ? (
                          <TableCell
                            component="th"
                            scope="row"
                            rowSpan={row.groups.date.count}
                            style={{
                              borderRight: "1px solid rgba(224, 224, 224, 1)",
                              paddingRight: "14px",
                            }}>
                            {row.date}
                          </TableCell>
                        ) : (
                          <React.Fragment />
                        )}

                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.agentCode}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.agentName}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.paknHaveLead}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.paknNoLead}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.sddvHaveLead}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.sddvNoLead}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.ychtHaveLead}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.ychtNoLead}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.sumTicket}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.sumInboundCall}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.inbNoTicket}
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  charts: {
    backgroundColor: "#fff",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
    "& p": {
      position: "absolute",
      top: "55px",
    },
  },
  form: {
    width: "100%",
  },
  rootDialog: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
    overflowX: "auto",
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: "#90a4ae",
    },
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f2f2f2",
    },
    "&:last-child": {
      backgroundColor: "#d9d9d9",
    },
  },
  head: {
    backgroundColor: "#f2f2f2",
    position: "sticky",
    top: 0,
  },
  button: {
    width: "40px",
    height: "40px",
    float: "right",
    marginTop: "-55px",
    fontSize: "16px",
  },
  fab: {
    marginRight: 10,
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
});

ReportTicket.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listReportTicket: state.reportTicket.report,
  loading: state.reportTicket.loading,
  listAgents: state.agent.agents,
});
const CampaignAction = connect(null, reportTicketAction)(ReportTicket);
const AgentAction = connect(null, agentAction)(CampaignAction);
ReportTicket = connect(mapStateToProps, mapActionsToProps)(AgentAction);
export default withStyles(styles)(ReportTicket);
